import {
  ActionSubmit,
  Form,
} from "@tandemdiabetes/sugarmate-react-components"
import type {
  FormEventHandler,
  ReactNode,
} from "react"
import { useCallback } from "react"
import styles from "./CountryProtectedPage.module.scss"
import { PublicPageCountryOfResidenceSelect } from "./PublicPageCountryOfResidenceSelect"
import { Logo } from "src/components/Logo"
import { OverlayLoader } from "src/components/OverlayLoader"
import {
  useCountrySelectionContext,
  usePolyglot,
} from "src/contexts"
import { useCountries } from "src/hooks"

interface Props {
  children?: ReactNode;
}

/*
 * if the user has not selected their country and confirmed their selection
 * then this component renders a country selection form, otherwise it renders
 * children
 */
export function CountryProtectedPage(props: Props) {
  const { isLoading } = useCountries()
  const {
    country,
    hasUserConfirmedCountrySelection,
    confirmCountrySelection,
  } = useCountrySelectionContext()
  const polyglot = usePolyglot()

  const onSubmit: FormEventHandler<HTMLFormElement> = useCallback(
    (ev) => {
      ev.preventDefault()

      confirmCountrySelection()
    },
    [confirmCountrySelection],
  )

  if (isLoading) {
    return <OverlayLoader visible/>
  }

  if (!country || !hasUserConfirmedCountrySelection) {
    return (
      <Form
        className={styles.container}
        onSubmit={onSubmit}
      >
        <Logo className={styles.logo} />
        <PublicPageCountryOfResidenceSelect />
        <ActionSubmit
          value={polyglot.t("components.country_protected_page.submit_cta")}
          stylePreset="primary"
          className={styles.submit}
        />
      </Form>
    )
  }

  return (
    <>
      {props.children}
    </>
  )
}
